import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncCreateSalesInvoiceModule = createAsyncThunk(
  "/fetchAsyncCreateInvoiceModule",
  async (data) => {
    try {
      const response = await axiosInstance.post('/sales-module/create', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncUpdateSalesInvoieModule = createAsyncThunk(
  "/fetchAsyncUpdateSalesInvoieModule",
  async (data) => {
    try {
      const response = await axiosInstance.post(`/sales-module/update/${data?.id}`, data?.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncUpdateModulePaymentTerms = createAsyncThunk(
  "/fetchAsyncUpdateModulePaymentTerms",
  async (data) => {
    try {
      const response = await axiosInstance.post(`/sales-module/update-terms/${data?.id}`, data?.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetSalesInvoiceModule = createAsyncThunk(
    "/fetchAsyncGetSalesInvoiceModule",
    async () => {
      try {
        let url = `${API_URL}/sales-module/get`;
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );

  export const fetchAsyncDeleteSalesInvoiceModule = createAsyncThunk(
    "/fetchAsyncDeleteSalesInvoiceModule",
    async (id) => {
      try {
        let url = `${API_URL}/sales-module/delete/${id}`;
        const response = await axiosInstance.delete(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );

  const AllSalesInvoiceModuleTypeSlice = createSlice({
    name: "salesModule",
    initialState,
    reducers: {},
    extraReducers: {
      [fetchAsyncGetSalesInvoiceModule.pending]: (state) => {},
      [fetchAsyncGetSalesInvoiceModule.fulfilled]: (state, { payload }) => {
        return payload;
      },
    },
  });

 
  export const getAllModuleType = (state) => state.salesModule;

export default AllSalesInvoiceModuleTypeSlice.reducer;

  



